import { render } from "./ShowOnMapButton.vue?vue&type=template&id=e45a833e"
import script from "./ShowOnMapButton.vue?vue&type=script&lang=js"
export * from "./ShowOnMapButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__